import PageProgress from "./components/PageProgress";

export default PageProgress;
